// src/pages/DoroosOnlineUserSelection.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';

import PageHeader from '../components/layout/PageHeader';
import OptionCard from '../components/cards/OptionCard';
import { useUser } from '../contexts/UserContext';
import { BookIcon, ShieldIcon } from '../components/common/IconsComponent';


const TEACHER_FEATURES = [
  'ניהול מערכת שעות',
  'יצירת שיעורים מקוונים',
  'מעקב אחר התקדמות תלמידים',
];

const STUDENT_FEATURES = [
  'צפייה בקורסים מקוונים',
  'הזמנת שיעורים פרטיים',
  'גישה לחומרי לימוד',
];

const SCHOOL_FEATURES = [
  'ניהול השתתפות בתוכניות גפ״ן',
  'ניהול תקציבים וקופונים',
  'מעקב אחר תלמידים ופעילות',
];

const SUPPLIER_FEATURES = [
  'ניהול תוכניות גפ״ן',
  'יצירת קורסים ציבוריים',
  'ניהול מורים, שיעורים והכנסות',
];


const DoroosOnlineUserSelection = () => {
  const navigate = useNavigate();
  const { setUserType } = useUser();

  const handleSelect = (type) => {
    setUserType(type);
    navigate('/AuthPage');
  };


  const options = [
    {
      title: 'מורים',
      description: 'כניסה למערכת כמורה לניהול שיעורים, קורסים ותלמידים',
      buttonText: 'התחבר כמורה',
      buttonGradient: 'bg-gradient-to-r from-indigo-600 to-purple-600',
      iconBgColor: 'bg-indigo-100',
      iconTextColor: 'text-indigo-600',
      features: TEACHER_FEATURES,
      icon: <BookIcon size={40} />,
      onSelect: () => handleSelect('teacher'),
    },
    {
      title: 'תלמידים',
      description: 'כניסה למערכת כתלמיד לצפייה בקורסים, שיעורים פרטיים וחומרי לימוד',
      buttonText: 'התחבר כתלמיד',
      buttonGradient: 'bg-gradient-to-r from-emerald-500 to-teal-500',
      iconBgColor: 'bg-emerald-100',
      iconTextColor: 'text-emerald-600',
      features: STUDENT_FEATURES,
      icon: <ShieldIcon size={40} />,
      onSelect: () => handleSelect('student'),
    },
    {
      title: 'בתי ספר',
      description: 'כניסה למערכת עבור בתי ספר לניהול תוכניות גפ״ן, תקציבים, קופונים ותלמידים',
      buttonText: 'התחבר כבית ספר',
      buttonGradient: 'bg-gradient-to-r from-blue-600 to-cyan-500',
      iconBgColor: 'bg-blue-100',
      iconTextColor: 'text-blue-600',
      features: SCHOOL_FEATURES,
      icon: <ShieldIcon size={40} />,
      onSelect: () => handleSelect('school'),
    },
    {
      title: 'מרכזי לימוד / ספקים',
      description: 'כניסה למערכת עבור מרכזי לימוד וספקים לניהול קורסים, תוכניות גפ״ן, מורים ותלמידים',
      buttonText: 'התחבר כמרכז לימוד',
      buttonGradient: 'bg-gradient-to-r from-violet-600 to-fuchsia-600',
      iconBgColor: 'bg-violet-100',
      iconTextColor: 'text-violet-600',
      features: SUPPLIER_FEATURES,
      icon: <BookIcon size={40} />,
      onSelect: () => handleSelect('supplier'),
    },
  ];


  return (
    <div className="min-h-screen bg-gray-100 flex flex-col" dir="rtl">

      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 overflow-hidden"
      >
        <div className="absolute -top-40 -right-40 w-80 h-80 rounded-full bg-indigo-100/60 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-purple-100/50 blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full bg-cyan-100/30 blur-3xl" />
      </div>

      <main className="relative flex-grow flex flex-col items-center justify-center px-3 sm:px-4 py-8 sm:py-12">

        <div className="w-full max-w-7xl mx-auto flex flex-col items-center gap-8 sm:gap-10">

          <PageHeader />

          <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {options.map((option) => (
              <OptionCard
                key={option.title}
                {...option}
              />
            ))}
          </div>

          <p className="text-xs sm:text-sm text-gray-400 text-center">
            בחר את סוג המשתמש או הארגון המתאים לך כדי להתחבר או להירשם
          </p>

        </div>

      </main>

    </div>
  );
};


export default DoroosOnlineUserSelection;